import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenAttendancesIndicatorM2 } from "@/services/esus/indicator/emulti/m2/getDetailedCitizenAttendancesIndicatorM2";
import { timeDimensionToString } from "@/utils/dateUtil";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEmultiM2AttendanceHistoryItem } from "./IndicatorEmultiM2AttendanceHistoryItem";
import { IndicatorEmultiM2GroupActivitiesHistoryItem } from "./IndicatorEmultiM2GroupActivitiesHistoryItem";
import { IndicatorEmultiM2CitizenHistoryInfo } from "./IndicatorEmultiM2CitizenHistoryInfo";
import { IndicatorEmultiM2DentalAttendanceHistoryItem } from "./IndicatorEmultiM2DentalAttendanceHistoryItem";
import { IndicatorEmultiM2SharedCareHistoryItem } from "./IndicatorEmultiM2SharedCareHistoryItem";

type IndicatorEmultiM2CitizenAttendancesHistoryProps = {
	citizenAttendances: DetailedCitizenAttendancesIndicatorM2;
};

export function IndicatorEmultiM2CitizenAttendancesHistory({
	citizenAttendances,
}: Readonly<IndicatorEmultiM2CitizenAttendancesHistoryProps>) {
	const indicatorEmultiM2CitizenHistoryInfo = {
		fullName: citizenAttendances.fullName ? citizenAttendances.fullName : "N/A",
		birthdate: citizenAttendances.birthdate
			? dayjs(citizenAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenAttendances.cpf
			? formatIdentifier(citizenAttendances.cpf)
			: citizenAttendances.cns ?? "",
		motherName: citizenAttendances.motherName ?? "",
		phone: citizenAttendances.phone ? phoneFormat(citizenAttendances.phone) : "",
		address:
			addressConcat(
				citizenAttendances.street,
				citizenAttendances.houseNumber,
				citizenAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEmultiM2CitizenHistoryInfo {...indicatorEmultiM2CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Atendimentos individuais"
				timeLineContents={(citizenAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: (
								<IndicatorEmultiM2AttendanceHistoryItem attendance={attendance} />
							),
							eventDate: attendance.timeDimensionId
								? timeDimensionToString(attendance.timeDimensionId, "DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Atendimentos odontológicos"
				timeLineContents={(citizenAttendances.dentalAttendances ?? []).map<TimeLineContent>(
					(dentalAttendance) => {
						return {
							content: (
								<IndicatorEmultiM2DentalAttendanceHistoryItem
									dentalAttendance={dentalAttendance}
								/>
							),
							eventDate: dentalAttendance.timeDimensionId
								? timeDimensionToString(
										dentalAttendance.timeDimensionId,
										"DD/MM/YYYY"
								  )
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Atividades coletivas"
				timeLineContents={(citizenAttendances.groupActivities ?? []).map<TimeLineContent>(
					(groupActivity) => {
						return {
							content: (
								<IndicatorEmultiM2GroupActivitiesHistoryItem
									groupActivity={groupActivity}
								/>
							),
							eventDate: groupActivity.timeDimensionId
								? timeDimensionToString(groupActivity.timeDimensionId, "DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
			<TimeLine
				timeLineTitle="Cuidados compartilhados"
				timeLineContents={(citizenAttendances.sharedCares ?? []).map<TimeLineContent>(
					(sharedCare) => {
						return {
							content: (
								<IndicatorEmultiM2SharedCareHistoryItem sharedCare={sharedCare} />
							),
							eventDate: sharedCare.timeDimensionId
								? timeDimensionToString(sharedCare.timeDimensionId, "DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
		</>
	);
}
